<div class="calendar">
  <header class="calendar__header">
    <button
      type="button"
      class="calendar__nav"
      (click)="goToPreviousMonth()"
      aria-label="Mes anterior"
    >
      <app-icon [icon]="chevronLeftIcon" [size]="20" />
    </button>

    <h3 class="calendar__month" aria-live="polite">{{ heading() }}</h3>

    <button
      type="button"
      class="calendar__nav"
      (click)="goToNextMonth()"
      aria-label="Mes siguiente"
    >
      <app-icon [icon]="chevronRightIcon" [size]="20" />
    </button>
  </header>

  @if (weeks().length > 0) {
    <table class="calendar__grid">
      <caption class="calendar__caption">
        Calendario de eventos de {{ heading() }}
      </caption>
      <thead>
        <tr>
          <!-- Las iniciales se repiten (M de martes y miércoles): el nombre
               completo va en el title para el lector de pantalla. -->
          @for (initial of weekdays; track $index) {
            <th scope="col" class="calendar__weekday">
              <abbr [title]="['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'][$index]">
                {{ initial }}
              </abbr>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (week of weeks(); track week[0].key) {
          <tr>
            @for (day of week; track day.key) {
              <td
                class="calendar__cell"
                [class.calendar__cell--outside]="!day.inMonth"
                [class.calendar__cell--today]="day.isToday"
                [class.calendar__cell--has-events]="day.events.length > 0"
              >
                <!-- Un día con eventos abre el diálogo: la lista del día o, si
                     solo hay uno, su detalle. -->
                <button
                  type="button"
                  class="calendar__day"
                  [disabled]="day.events.length === 0"
                  [attr.aria-label]="dayAriaLabel(day)"
                  [attr.aria-haspopup]="day.events.length > 0 ? 'dialog' : null"
                  (click)="openDay(day)"
                >
                  <span class="calendar__day-number">{{ day.dayOfMonth }}</span>

                  <!-- Escritorio: los títulos que caben. -->
                  <span class="calendar__day-events" aria-hidden="true">
                    @for (event of day.events.slice(0, visiblePerDay); track event.id) {
                      <span class="calendar__event" [attr.data-type]="event.type">
                        {{ event.name }}
                      </span>
                    }
                    @if (hiddenCount(day) > 0) {
                      <span class="calendar__more">+{{ hiddenCount(day) }}</span>
                    }
                  </span>

                  <!-- Móvil: un punto por evento, hasta tres. -->
                  <span class="calendar__dots" aria-hidden="true">
                    @for (event of day.events.slice(0, 3); track event.id) {
                      <span class="calendar__dot" [attr.data-type]="event.type"></span>
                    }
                  </span>
                </button>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  }
</div>
